import { type MutableRefObject, type RefObject, useRef } from "react";
import { useReactToPrint } from "react-to-print";

type UsePrintPageProps<T extends HTMLDivElement = HTMLDivElement> = {
  customRef?: RefObject<T> | MutableRefObject<T | null>;
};

export function usePrintPage<T extends HTMLDivElement = HTMLDivElement>({
  customRef,
}: UsePrintPageProps<T>) {
  const componentRef = useRef<T>(null);

  const handlePrintPage = useReactToPrint({
    content: () => customRef?.current ?? componentRef.current,
    pageStyle: `
        @media all {
          .page-break {
            display: none;
          }
        }
        @media print {
          html, body {
            height: initial !important;
            overflow: initial !important;
            -webkit-print-color-adjust: exact;
          }
          .page-break {
            display: block;
            page-break-before: auto;
          }
        }
        @page {
          size: auto;
          margin: 6mm 0 0 0;
          size: portrait;
        }
      `,
  });

  return {
    ref: customRef ?? componentRef,
    handlePrintPage,
  };
}
